// extracted by mini-css-extract-plugin
export default {"accountHeader":"_m-z","newDesignAccountHeader":"an-z","primeBadge":"bn-z","logout":"cn-z"};